import React, { useState, useEffect } from 'react';
import {
  Box,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Heading,
  Text,
  useToast,
} from '@chakra-ui/react';
import AllCertificatesTab from './tabs/AllCertificatesTab';
import InstitutionSettingsTab from './tabs/InstitutionSettingsTab';
import GlobalResourcesTab from './tabs/GlobalResourcesTab';
import TemplatesManagementTab from './tabs/TemplatesManagementTab';
import AuditLogsTab from './tabs/AuditLogsTab';
import { canvasAPI } from '../../services/api';


const AdminPanel = () => {
  const [certificates, setCertificates] = useState([]);
  const [settings, setSettings] = useState(null);
  const [auditLogs, setAuditLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const toast = useToast();

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      await Promise.all([
        loadCertificates(),
        loadSettings(),
        loadAuditLogs(),
      ]);
    } catch (error) {
      console.error('Error loading admin data:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadCertificates = async () => {
    try {
      const response = await canvasAPI.getAllCertificates();
      setCertificates(response.certificates || []);
    } catch (error) {
      console.error('Error loading certificates:', error);
      toast({
        title: 'Error',
        description: 'No se pudo cargar los certificados',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const loadSettings = async () => {
    try {
      const response = await canvasAPI.getInstitutionSettings();
      setSettings(response.settings || null);
    } catch (error) {
      console.error('Error loading settings:', error);
      toast({
        title: 'Error',
        description: 'No se pudo cargar la configuración',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const loadAuditLogs = async () => {
    try {
      const response = await canvasAPI.getAuditLogs({ limit: 100 });
      setAuditLogs(response.logs || []);
    } catch (error) {
      console.error('Error loading audit logs:', error);
      toast({
        title: 'Error',
        description: 'No se pudo cargar los logs de auditoría',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <Box maxW="7xl" mx="auto" py={8} px={4}>
      {/* Header */}
      <Box mb={6}>
        <Heading size="xl" mb={2}>
          Panel de Administración
        </Heading>
        <Text color="gray.600">
          Gestión global de certificados, configuración institucional y auditoría
        </Text>
      </Box>

      {/* Tabs */}
      <Tabs colorScheme="blue" variant="enclosed" isLazy>
        <TabList>
          <Tab>Todos los Certificados</Tab>
          <Tab>Configuración Institucional</Tab>
          <Tab>Plantillas de Certificados</Tab>
          <Tab>Variables e Imágenes Globales</Tab>
          <Tab>Logs de Auditoría</Tab>
        </TabList>


        <TabPanels>
          <TabPanel px={0}>
            <AllCertificatesTab
              certificates={certificates}
              loading={loading}
              onRefresh={loadCertificates}
            />
          </TabPanel>

          <TabPanel px={0}>
            <InstitutionSettingsTab
              settings={settings}
              loading={loading}
              onRefresh={loadSettings}
            />
          </TabPanel>

          <TabPanel px={0}>
            <TemplatesManagementTab settings={settings} />
          </TabPanel>

          <TabPanel px={0}>
            <GlobalResourcesTab
              settings={settings}
              loading={loading}
              onRefresh={loadSettings}
            />
          </TabPanel>


          <TabPanel px={0}>
            <AuditLogsTab
              logs={auditLogs}
              loading={loading}
              onRefresh={loadAuditLogs}
            />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default AdminPanel;
